import React from "react";
import { Link } from "react-router-dom";
import Mailto from "react-mailto-link";


const ButtonMailto = ({ mailto, label }) => {
    const mail = () => {
        console.log(window.location)
        window.location.href = mailto;
        console.log(window.location)
    }

    return (
        <Mailto email={label} obfuscated={true}>
            <div>{label}</div>
        </Mailto>
    );
};

export default ButtonMailto;